import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Partner } from "../components/Partner";
import AOS from "aos";
import "aos/dist/aos.css";
import ReCAPTCHA from "react-google-recaptcha";

export const ContactUs = () => {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });
    const [status, setStatus] = useState("");

    const [captchaValue, setCaptchaValue] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaValue) {
            setStatus("❌ Please verify reCAPTCHA");
            return;
        }

        setStatus("Sending...");

        console.log('formData', formData);
        // return

        try {
            const res = await fetch("https://sewainsurance.com/sendMail.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            const result = await res.json();

            if (result.success) {
                setStatus("✅ Message sent successfully!");
            } else {
                setStatus("❌ Failed: " + result.message);
            }
        } catch (error) {
            console.log('error', error);
            setStatus("❌ Error sending email");
        }
    };

    useEffect(() => {
        AOS.init({
            duration: 1500,
            once: true,
            disable: function () {
                return window.innerWidth < 992;
            },
        });
    }, []);

    return (
        <div className="page-content servicepage">
            <section className="wi_full py_3 inner_banner" style={{
                backgroundImage: "url('./images/contact-banner.jpg')", backgroundSize: "cover",
                backgroundPosition: "center", backgroundRepeat: "no-repeat",
            }}>
                <div className="container" data-aos="fade-in">
                    <h1>Contact Us</h1>
                </div>
            </section>
            <section className="get_in_touch mt_3 wi_full">
                <div className="container">
                    <div className="sec_title text-center">
                        <h2>Get in touch <span>with us</span></h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                    </div>
                    <div className="row git_row" data-aos="fade-up">
                        <div className="col-md-4 col_item">
                            <div className="item_inner">
                                <span className="itm_icon"><img src="./images/location-white.svg" /></span>
                                <h3>Location</h3>
                                <p>Located in New Jersey — Serving clients across the country</p>
                            </div>
                        </div>
                        <div className="col-md-4 col_item">
                            <Link to="mailto: info@sewainsurance.com" className="item_inner">
                                <span className="itm_icon"><img src="./images/envelope-white.svg" /></span>
                                <h3>Quick Email</h3>
                                <p>info@sewainsurance.com</p>
                            </Link>
                        </div>
                        <div className="col-md-4 col_item">
                            <Link to="tel: 6462430077" className="item_inner">
                                <span className="itm_icon"><img src="./images/phone-white.svg" /></span>
                                <h3>Tell With Us</h3>
                                <p>(646) 243-0077</p>
                            </Link>
                        </div>
                    </div>
                    <div className="btn_block d-flex justify-content-center" data-aos="fade-up">
                        <a href="https://calendly.com/preet-sewainsurance/30min" target="_blank" className="button fill_btn">Book Your Appointment</a>
                    </div>
                    <div className="contact_form mt_3" data-aos="fade-up">
                        <h2 className="text-center mb-4">Contact Us</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-sm-6 form-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Name"
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="col-sm-6 form-group">
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Email"
                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="col-sm-12 form-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Phone"
                                        value={formData.phone}
                                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                    />
                                </div>
                                <div className="col-sm-12 form-group">
                                    <textarea
                                        className="form-control"
                                        rows="5"
                                        placeholder="Message"
                                        value={formData.message}
                                        onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                        required
                                    ></textarea>
                                </div>
                                {/* reCAPTCHA */}
                                <div className="col-sm-12 form-group d-flex justify-content-center google_captcha">
                                    <ReCAPTCHA
                                        sitekey="6Lc9AsorAAAAAGSeuEWJY5_uBHFePOdm8xOtYEPD"
                                        onChange={(value) => setCaptchaValue(value)}
                                    />
                                </div>
                                <div className="col-sm-12 form-btn d-flex justify-content-center">
                                    <input type="submit" className="button fill_btn" value="Submit" />
                                </div>
                            </div>

                            {status && <p style={{ textAlign: "center", marginTop: "10px" }}>{status}</p>}
                        </form>
                    </div>
                </div>
            </section>
            <section className="map_sec">
                {/* <img src="./images/map.jpg" className="w-100" /> */}
            </section>
            <Partner />
        </div>
    )
}